<template>
    <div class="user-groups fh">
      <div class="setting-header v-center space-between px-5">
      <div class="setting-heading-box">
          <img class="btn-icon setting-icon" src="~@/assets/images/icons/sequence-generator-icon.svg" alt="" width="15px" />
        <h1 class="setting-name">
          Sequence Generation
        </h1>
          <p class="setting-subscript">Configuration for automatic numbering and identifiers</p>
      </div>
        <div class="v-center">
          <div class="input-group search m mx-3">
            <input
              v-model="searchKeyword"
              type="text"
              @input="updateOnSearch"
              placeholder="Search"
            />
          </div>

        <!-- ✅ Feature Filter Dropdown -->
        <div class="input-group m mx-2">
          <select v-model="selectedFeature" class="feature-filter-select" @change="updateOnFeatureChange">
            <option :value="-1">All Features</option>
            <option
              v-for="(featureId, featureName) in featureOptions"
              :key="featureId"
              :value="featureId"
            >
              {{ featureName }}
            </option>
          </select>
        </div>

          <div>
               <button v-if="isTenantAdmin" @click="goToCreate" class="btn">+ Create Template</button>
          </div>
        </div>
      </div>
      <div class="user-groups-container pt-2">
        <div class="fh center" v-if="loading">
          <loading-circle />
          </div>
        <div v-else-if="totalCount === 0" class="user-groups-no-form fh center">
          No Data Found
        </div>
        <div class="copy-dtx-table user-groups-table" v-else>
        <table v-if="templates.length" class="sequence-table">
          <colgroup>
            <col class="col-name">
            <col class="col-feature">
            <col class="col-preview">
            <col class="col-created">
            <col v-if="isTenantAdmin" class="col-action">
          </colgroup>
          <thead>
          <tr class="m">
        <th>Name</th>
        <th>Feature</th>
        <th>Preview</th>
        <th class="sortable-header" @click.stop="toggleCreatedOnSort">
          <span>Created</span>
          <img
            v-if="createdOnSort === 'asc'"
            src="~@/assets/images/icons/arrow-up-icon.svg"
            alt="Sort ascending"
            width="14"
            height="14"
          />
          <img
            v-else
            src="~@/assets/images/icons/arrow-down-icon.svg"
            alt="Sort descending"
            width="14"
            height="14"
          />
        </th>
        <th v-if="isTenantAdmin">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
        v-for="template in templates"
        :key="template.id"
        @click="goToView(template.id)"
      >
        <td v-overflow-tooltip class="elipsis-text">{{ template.name }}</td>
        <td>
          <span
            v-overflow-tooltip
            :class="['feature-chip', getFeatureChipClass(template.core_feature.id)]"
          >
            {{ template.core_feature.name.replaceAll('_', '  ') }}
          </span>
        </td>
        <td class="preview-cell elipsis-text" v-overflow-tooltip>
          <span
            v-for="(part, idx) in generateTemplatePreview(template.sequence_rules)"
            :key="idx"
            class="preview-part"
            v-html="part.text"
          ></span>
        </td>
        <td class="audit-cell">
            <span class="audit-name" v-overflow-tooltip>  {{ template.created_by_user.first_name }}
           {{ template.created_by_user.last_name }}</span>
            <span class="audit-date">{{ template.created_at  | genericFormatDate}} </span>
        </td>
        <td class="action-cell" v-if="isTenantAdmin">
          <span v-if="template.active" v-tooltip="'Deactivate Template'" class="pointer" @click.stop="deactivateTemplate(template.id, template.core_feature.name)">
            <img width="20" src="~@/assets/images/trash-2.svg"/>
          </span>
          <span v-else v-tooltip="'Activate Template'" class="pointer" @click.stop="activateTemplate(template.id)">
          <img width="20" src="~@/assets/images/icons/undo-icon.svg"/>
          </span>
        </td>
        </tr>
            <!-- No results after filter -->
            <tr v-if="templates.length === 0">
              <td :colspan="isTenantAdmin ? 5 : 4" class="no-data">No templates found for selected feature.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-footer space-between">
          <pagination2
        :length="totalCount" :pageNumber="pageNumber" :perPage="perPage"
          @selectPage="selectPage"
        class="mt-3 mx-2"
      />
        <span class="pagination-footer-total mt-4"  v-if="templates.length > 0">Total Sequence Generation  : &nbsp; <b> {{ totalCount }}</b></span>
      </div>
      </div>
    </div>
  </template>
<script>
import { ActivateTemplate, DeactivateTemplate, GetTemplateData } from '@/api'
import { mapGetters } from 'vuex'
import pagination2 from '@/components/common/pagination2.vue'
import loadingCircle from '@/components/common/loadingCircle.vue'
import { debounce } from '@/utils/debounce'
import { alert, success } from '@/plugins/notification'
import config from '@/config'
import { genericFormatDate } from '@/utils/date'
export default {
  name: 'PartIdGeneration',
  components: { pagination2, loadingCircle },
  filters: {
    genericFormatDate
  },
  data () {
    return {
      preview: '', // the main uppercase preview
      subscriptLabels: [],
      coreFeatures: config.CORE_FEATURES,
      loading: false,
      searchKeyword: '',
      totalCount: 0,
      pageNumber: 1,
      perPage: 10,
      updateOnSearch: null,
      templates: [],
      disableButton: false,
      selectedFeature: -1,
      createdOnSort: 'desc',
      featureOptions: {
        Material: 1,
        Forms: 5,
        'Product Code': 6,
        Factory: 12
      }
    }
  },
  computed: {
    ...mapGetters(['isTenantAdmin', 'user']),
    userInitials () {
      const firstInitial = this.user?.first_name?.charAt(0) || ''
      const lastInitial = this.user?.last_name?.charAt(0) || ''
      return (firstInitial + lastInitial).toUpperCase()
    }
  },
  created () {
    this.updateOnSearch = debounce(() => {
      this.pageNumber = 1
      this.fetchSequenceTemplates()
    }, 500)
    this.fetchSequenceTemplates()
  },
  mounted () {
    // this.fetchSequenceTemplates()
  },
  methods: {
    updateOnFeatureChange () {
      this.pageNumber = 1
      this.fetchSequenceTemplates()
    },
    generateTemplatePreview (rules) {
      if (!Array.isArray(rules)) return []

      const sorted = rules.slice().sort((a, b) => a.sequence_order - b.sequence_order)

      return sorted.map(rule => {
        const typeRaw = rule.component_name
        const type = typeRaw ? typeRaw.trim().toLowerCase() : 'undefined'
        let text = ''
        let label = null
        if (type === 'auto sequence') {
          const raw = String(rule.start_value ?? '')
          const paddingLength = rule.padding_length || 0
          const padded = paddingLength > 0 ? '0'.repeat(paddingLength) + raw : raw
          text = String(padded)
        } else if (type === 'auto_sequence') {
          const raw = String(rule.start_value ?? '')
          const paddingLength = rule.padding_length || 0
          const padded = paddingLength > 0 ? '0'.repeat(paddingLength) + raw : raw
          text = String(padded)
        } else if (type === 'number') {
          text = rule.default_value != null ? String(rule.default_value) : 'XX'
        } else if (type === 'month') {
          text = 'MM'
        } else if (type === 'year') {
          text = 'YYYY'
        } else if (type === 'date') {
          text = 'DD'
        } else if (type === 'config list') {
          text = '[config]'
          label = 'config'
        } else if (type === 'tags') {
          text = '[tags]'
          label = 'tags'
        } else if (type === 'uuid') {
          text = '[uuid]'
          label = 'uuid'
        } else if (type === 'user initials') {
          text = this.userInitials
        } else if (type === 'text') {
          text = rule?.default_value || ''
        } else {
          text = ''
        }

        if (rule.delimiter_after) {
          text += rule.delimiter_after
        }

        const highlightedText = text.toUpperCase().replace(
          /\[([^\]]+)\]/g,
          '<strong>[$1]</strong>'
        )

        return { text: highlightedText, label }
      })
    },

    goToView (id) {
      this.$router.push(`/settings/sequence-generator/view/${id}`)
    },
    deleteTemplate (id) {
      alert('Delete option disabled for now')
    },
    deactivateTemplate (id, templateFeatureName) {
      if (this.disableButton) return
      this.disableButton = true
      DeactivateTemplate(id).then(res => {
        if (res) {
          success('Template deactivated')
          this.fetchSequenceTemplates()
        }
      }).catch((err) => {
        if (err?.graphQLErrors[0]?.message.includes('database query error')) {
          alert(`Cannot deactivate because it is the only ${templateFeatureName} template`)
        } else {
          alert('Error deactivating template')
        }
      }).finally(() => {
        this.disableButton = false
      })
    },
    activateTemplate (id) {
      if (this.disableButton) return
      this.disableButton = true
      ActivateTemplate(id).then(res => {
        if (res) {
          success('Template activated successfully')
          this.fetchSequenceTemplates()
        }
      }).catch(() => {
        alert('Error activating template')
      }).finally(() => {
        this.disableButton = false
      })
    },
    selectPage (pageNumber) {
      this.pageNumber = pageNumber
      this.fetchSequenceTemplates()
    },
    toggleCreatedOnSort () {
      this.createdOnSort = this.createdOnSort === 'desc' ? 'asc' : 'desc'
      this.pageNumber = 1
      this.fetchSequenceTemplates()
    },
    getFeatureChipClass (featureId) {
      const featureClassMap = {
        [config.CORE_FEATURES.MATERIAL]: 'feature-chip--material',
        [config.CORE_FEATURES.BOM]: 'feature-chip--bom',
        [config.CORE_FEATURES.DOCUMENTS]: 'feature-chip--documents',
        [config.CORE_FEATURES.TASKS]: 'feature-chip--tasks',
        [config.CORE_FEATURES.FORMS]: 'feature-chip--forms',
        [config.CORE_FEATURES.PRODUCT_CODE]: 'feature-chip--product-code',
        [config.CORE_FEATURES.USERS]: 'feature-chip--users',
        [config.CORE_FEATURES.CHECKLIST]: 'feature-chip--checklist',
        [config.CORE_FEATURES.TENANT]: 'feature-chip--tenant',
        [config.CORE_FEATURES.FACTORY]: 'feature-chip--factory'
      }

      return featureClassMap[featureId] || 'feature-chip--default'
    },
    goToCreate () {
      this.$router.push('/settings/sequence-generator/create')
    },
    fetchSequenceTemplates () {
      const jump = (this.pageNumber - 1) * this.perPage
      this.loading = true
      GetTemplateData(jump, this.perPage, this.searchKeyword, 'ALL', false, this.selectedFeature, this.createdOnSort).then(res => {
        if (res) {
          this.templates = res.core_sequence_id_template
          this.totalCount = res.core_sequence_id_template_aggregate.aggregate.count
        }
        this.loading = false
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.sequence-table {
  width: 100%;
  table-layout: fixed;
}

.sequence-table th,
.sequence-table td {
  overflow: hidden;
}

.sequence-table .col-name {
  width: 24%;
}

.sequence-table .col-feature {
  width: 16%;
}

.sequence-table .col-preview {
  width: 30%;
}

.sequence-table .col-created {
  width: 22%;
}

.sequence-table .col-action {
  width: 72px;
}

.sequence-table td:not(.audit-cell):not(.action-cell),
.sequence-table th {
  white-space: nowrap;
  text-overflow: ellipsis;
}

.feature-chip {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: var(--text-xs1);
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.feature-chip--material {
  background: #faf5ff;
  color: #7c3aed;
}

.feature-chip--bom {
  background: #ecfeff;
  color: #155e75;
}

.feature-chip--documents {
  background: #fff1f2;
  color: #e31273;
}

.feature-chip--tasks {
  background: #f5f3ff;
  color: #6d28d9;
}

.feature-chip--forms {
  background: #eef2ff;
  color: #4338ca;
}

.feature-chip--product-code {
  background: #fff7ed;
  color: #c2410c;
}

.feature-chip--users {
  background: #fff7ed;
  color: #f49922;
}

.feature-chip--checklist {
  background: #fefce8;
  color: #a16207;
}

.feature-chip--tenant {
  background: #eef2ff;
  color: #3730a3;
}

.feature-chip--factory {
  background: #f0fdf4;
  color: #32500a;
}

.feature-chip--default {
  background: #f3f4f6;
  color: #111827;
}

.preview-cell {
  padding: 0 15px;
  margin: 0;
}

.audit-cell {
  white-space: normal !important;
  line-height: 1.2;
}
.audit-name,
.audit-date {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.audit-name {
  font-size: var(--text-xs2);
  font-weight: 400;
  color: #111827;
}
.audit-date {
  margin-top: 4px;
  font-size: var(--text-xs);
  color: #6b7280;
}

.preview-table {
  border-collapse: collapse;
  border: none;
  width: auto;
}

.preview-table td,
.preview-table tr {
  border: none;
  padding: 0;
  margin: 0;
}

.preview-row {
  height: auto;
  line-height: 1; // tight
  padding: 0;
  margin: 0;
}

.preview-part {
  font-size: var(--text-s);
  text-align: center;
  vertical-align: bottom;
  line-height: 1;
}
.preview-label {
  font-size: var(--text-xs);
  color: #374151; // slightly darker readable grey
  text-align: center;
  vertical-align: top;
  line-height: 1;
  padding: 0;
  margin: 0;
}

.feature-filter-select {
  height: 34px;
  padding: 0 28px 0 10px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  color: var(--text-color);
  font-size: var(--text-s);
  cursor: pointer;
  appearance: none;
  min-width: 150px;

  &:focus {
    outline: none;
    border-color: var(--brand-color, #f5a623);
  }
}

.sortable-header {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;

  span,
  img {
    vertical-align: middle;
  }

  img {
    margin-left: 6px;
  }
}

.header {
    &-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 2px solid #ddd;
        margin-bottom: 10px;
    }
    &-container {
    padding-block: 10px;
    }
  }
  .search-container {
  width: 100%;
  display: flex;
  margin-bottom: 5px;
  justify-content: flex-end;
  }
    .pagination-footer {
    width: 100%;
    display: flex;
    justify-content: space-between;

    &-total {
      margin-top: 16px;
      display: flex;
      padding: 0.5rem 0.5rem 0.5rem;
      border-radius: 0.2em;
      width: fit-content;
      padding-inline: 10px;
      margin-left: auto;
    }
  }
  .no-data {
    text-align: center;
    vertical-align: middle;
  }
@media (max-width: 1366px) and (max-height: 633px) {
  .list-table {
    height: calc(100% - 150px);
  }
}
  .user-groups {
    .user-group-name {
       max-width: 80px;
    }
    .description {
        max-width: 60px;
    }
    &-container {
      height: calc(100% - 60px);
    }
    &-table {
      height: calc(100% - 60px);
    }
    &-no-form {
      font-size: var(--text-2xl);
      color: var(--text-color);
    }
    &-group {
      overflow: auto;
      position: relative;
      & > div {
        & > div {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          & > div {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        }
      }
      &-header {
        background-color: var(--brand-color);
        position: sticky;
        top: 0;
        &-item {
          padding: 4px 10px;
          font-size: var(--text-base);
          font-weight: 600;
          color: var(--text-color);
        }
      }
      &-row {
        display: grid;
        grid-template-columns: 2fr 3fr 1fr 1fr 80px;
      }
      &-item {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        & > div {
          padding: 4px 10px;
          font-size: var(--text-base);
          color: var(--text-color);
        }
      }
    }
    &-preview {
      &-header {
        padding: 5px 10px;
        background: var(--brand-color);
        & > h3 {
          font-size: var(--text-base);
          font-weight: 600;
          color: var(--text-color);
        }
      }
      &-body {
        height: calc(100% - 40px);
        padding: 10px;
        background: var(--bg-color);
        overflow-y: auto;
      }
    }
  }

</style>
